import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { isProductSoldOut } from 'featureSliced/shared/utils/soldOut'

export const useIsProductSoldOut = (
  product: Pick<IProduct, 'id' | 'soldOut'>
): boolean => {
  const soldOutIds = useMySelector((state) => state.categories.soldOutIds)
  return isProductSoldOut(product, soldOutIds)
}
